// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"11":"0e89fbae","20":"e3b74a8d","135":"e3b74a8d"}[chunkId] + ".css";
};